(() => {
  if (window.__ffienleeProductGalleryHoverZoom) return;
  window.__ffienleeProductGalleryHoverZoom = true;

  const desktopHover = window.matchMedia(
    '(min-width: 750px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)'
  );
  const slideSelector =
    "#MainContent[data-template^='product'] media-gallery.media-gallery--carousel slideshow-slide[aria-hidden='false'].product-media-container--image.product-media-container--zoomable";

  let activeSlide = null;
  let pendingPointer = null;
  let animationFrame = 0;

  const resetSlide = (slide) => {
    if (!slide) return;

    slide.removeAttribute('data-ffienlee-hover-zoom');
    slide.style.removeProperty('--ffienlee-zoom-x');
    slide.style.removeProperty('--ffienlee-zoom-y');
  };

  const cancelPendingUpdate = () => {
    pendingPointer = null;

    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = 0;
    }
  };

  const clearActiveSlide = () => {
    cancelPendingUpdate();
    resetSlide(activeSlide);
    activeSlide = null;
  };

  const applyPointerPosition = () => {
    animationFrame = 0;

    if (!pendingPointer || !desktopHover.matches) return;

    const { slide, clientX, clientY } = pendingPointer;
    pendingPointer = null;

    const bounds = slide.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return;

    if (activeSlide && activeSlide !== slide) resetSlide(activeSlide);

    const x = Math.min(100, Math.max(0, ((clientX - bounds.left) / bounds.width) * 100));
    const y = Math.min(100, Math.max(0, ((clientY - bounds.top) / bounds.height) * 100));

    slide.style.setProperty('--ffienlee-zoom-x', `${x.toFixed(2)}%`);
    slide.style.setProperty('--ffienlee-zoom-y', `${y.toFixed(2)}%`);
    slide.setAttribute('data-ffienlee-hover-zoom', 'true');
    activeSlide = slide;
  };

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!desktopHover.matches || event.pointerType === 'touch' || !(event.target instanceof Element)) {
        clearActiveSlide();
        return;
      }

      const slide = event.target.closest(slideSelector);
      if (!slide) {
        clearActiveSlide();
        return;
      }

      pendingPointer = { slide, clientX: event.clientX, clientY: event.clientY };

      if (!animationFrame) animationFrame = window.requestAnimationFrame(applyPointerPosition);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    (event) => {
      if (!activeSlide) return;

      const nextTarget = event.relatedTarget;
      if (!(nextTarget instanceof Node) || !activeSlide.contains(nextTarget)) clearActiveSlide();
    },
    { passive: true }
  );

  document.addEventListener('click', (event) => {
    if (activeSlide && event.target instanceof Element && event.target.closest(slideSelector)) clearActiveSlide();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') clearActiveSlide();
  });

  window.addEventListener('pagehide', clearActiveSlide);

  if (typeof desktopHover.addEventListener === 'function') {
    desktopHover.addEventListener('change', clearActiveSlide);
  } else {
    desktopHover.addListener(clearActiveSlide);
  }
})();
